module.exports = __webpack_public_path__ + "static/media/failed.75af9835.png";